import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Grid } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledBox = styled(Box)(({ theme, image }) => ({
  borderTopRightRadius: 12,
  borderTopLeftRadius: 12,
  color: theme.palette.grey[50],
  textAlign: "center",
  minHeight: "220px",
  backgroundImage: `url(${image})`,
  backgroundPosition: "center",
  backgroundSize: "cover"
}))

export const StyledGrid = styled(Grid)({
  display: "flex"
})

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.primary[700],
  marginRight: 8
}))
